module.exports = __webpack_public_path__ + "img/RebateList-Rebate.8419d25a.png";